/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserFeedback
 */
export interface UserFeedback {
    /**
     * 
     * @type {string}
     * @memberof UserFeedback
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserFeedback
     */
    clinic_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserFeedback
     */
    physician_id?: string;
    /**
     * 
     * @type {number}
     * @memberof UserFeedback
     */
    rating?: number;
    /**
     * 
     * @type {string}
     * @memberof UserFeedback
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof UserFeedback
     */
    patient_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserFeedback
     */
    appointment_id?: string;
    /**
     * 
     * @type {number}
     * @memberof UserFeedback
     */
    date?: number;
    /**
     * 
     * @type {string}
     * @memberof UserFeedback
     */
    name?: string;
}

/**
 * Check if a given object implements the UserFeedback interface.
 */
export function instanceOfUserFeedback(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserFeedbackFromJSON(json: any): UserFeedback {
    return UserFeedbackFromJSONTyped(json, false);
}

export function UserFeedbackFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserFeedback {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'clinic_id': !exists(json, 'clinic_id') ? undefined : json['clinic_id'],
        'physician_id': !exists(json, 'physician_id') ? undefined : json['physician_id'],
        'rating': !exists(json, 'rating') ? undefined : json['rating'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'patient_id': !exists(json, 'patient_id') ? undefined : json['patient_id'],
        'appointment_id': !exists(json, 'appointment_id') ? undefined : json['appointment_id'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function UserFeedbackToJSON(value?: UserFeedback | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'clinic_id': value.clinic_id,
        'physician_id': value.physician_id,
        'rating': value.rating,
        'text': value.text,
        'patient_id': value.patient_id,
        'appointment_id': value.appointment_id,
        'date': value.date,
        'name': value.name,
    };
}

